import { useRef as e } from "react";
import a from "../../../rc-util/es/raf.mjs";
import R from "../utils/isFirefox.mjs";
import d from "./useOriginScroll.mjs";
function w(u, c, i, m) {
  var t = e(0), l = e(null), f = e(null), o = e(!1), p = d(c, i);
  function s(r) {
    if (u) {
      a.cancel(l.current);
      var n = r.deltaY;
      t.current += n, f.current = n, !p(n) && (R || r.preventDefault(), l.current = a(function() {
        var F = o.current ? 10 : 1;
        m(t.current * F), t.current = 0;
      }));
    }
  }
  function v(r) {
    u && (o.current = r.detail === f.current);
  }
  return [s, v];
}
export {
  w as default
};
//# sourceMappingURL=useFrameWheel.mjs.map
